import darkThemeFactory from './mode/dark'
import okenLightThemeFactory from './mode/light.oken'

export default okenLightThemeFactory(
  '#092C4C',
  '#092C4C',
  '#092C4C',
  '#1453F1',
  {
    primary: 'Inter',
    secondary: 'Inter',
  }
)
export const defaultMode = 'light'
export const alternativeMode = darkThemeFactory(
  '#092C4C',
  '#092C4C',
  '#092C4C',
  '#1453F1',
  {
    primary: 'Inter',
    secondary: 'Inter',
  }
)
